import store from '@/store';
import { api } from '@/utils/api';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvoices(ctx, queryParams) {
      console.log('=== SalesInvoiceStoreModule fetchSalesInvoices():', { queryParams });

      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        console.log('=== SalesInvoiceStoreModule businessID', businessID);

        const params = {
          businessID,
          pageNumber: queryParams.pageNumber || 1,
          pageSize: queryParams.pageSize || 10,
          searchTerm: queryParams.searchTerm || '',
          fbrStatus: queryParams.fbrStatus || '',
          customerID: queryParams.customerID || '',
          salesTypeID: queryParams.salesTypeID || '',
          fbrInvoiceNumber: queryParams.fbrInvoiceNumber || '',
          saleDateFrom: queryParams.saleDateFrom || '',
          saleDateTo: queryParams.saleDateTo || '',
        };

        console.log('=== SalesInvoiceStoreModule params', params);

        api
          .get(`/SalesInvoiceFBR/GetByPagination/${businessID}`, { params })
          .then((response) => {
            console.log('=== SalesInvoiceStoreModule response', response.data);

            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching Unit of Measures list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID;

        api
          .get(`/SalesInvoiceFBR/LoadSelectedData/${businessID}?userID=${userID}&id=${id}`)
          .then((response) => {
            console.log('=== SalesInvoiceStoreModule response', response.data);
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching Unit of Measures list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchMonthlySummaryReport(ctx, { monthName, year }) {
      const businessID = store.state.user.businessID;
      return new Promise((resolve, reject) => {
        api
          .get(`/SalesInvoiceFBR/GetMonthlySummaryReport/${businessID}`, {
            params: {
              monthName,
              year,
            },
          })
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject(response.data.message || 'Error fetching Monthly Summary Report');
            }
          })
          .catch((error) => reject(error));
      });
    },
    addInvoice(ctx, invoiceData) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID;

        api
          .post(`/SalesInvoiceFBR/Save/${businessID}?userID=${userID}`, invoiceData)
          .then((response) => {
            console.log(response);

            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject(response.data.message);
            }
          })
          .catch((error) => reject(error));
      });
    },
    editInvoice(ctx, invoiceData) {
      return new Promise((resolve, reject) => {
        api
          .post(`/SalesInvoiceFBR/Save`, uomData)
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    deleteInvoice(ctx, invoiceId) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;

      return new Promise((resolve, reject) => {
        api
          .delete(`/SalesInvoiceFBR/Delete/${invoiceId}/${businessID}`, {
            params: {
              userID: userID,
            },
          })
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.message);
            } else {
              reject(response.data.message);
            }
          })
          .catch((error) => reject(error));
      });
    },
    bulkUploadInvoice(ctx, invoiceData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;

      return new Promise((resolve, reject) => {
        api
          .post(`/SalesInvoiceFBR/BulkUpload/${businessID}?userID=${userID}`, invoiceData)
          .then((response) => {
            resolve(response);
          });
      });
    },
    UploadToFBR(ctx, ids) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;

      return new Promise((resolve, reject) => {
        api
          .post(`/SalesInvoiceFBR/UploadToFBR/${businessID}?userID=${userID}`, ids)
          .then((response) => {
            console.log('=== SalesInvoiceStoreModule UploadToFBR response', response.data);

            // Resolve with the full response data so the UI can show results modal
            // Regardless of whether it's status 'success' or 'error', 
            // the UI will handle showing the details.
            resolve(response.data);
          })
          .catch((error) => {
            console.error('=== SalesInvoiceStoreModule UploadToFBR error', error);
            reject(error);
          });
      });
    },
    BulkDelete(ctx, ids) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;

      return new Promise((resolve, reject) => {
        // You can use this API for your backend rights-based access checking logic
        api
          .post(`/SalesInvoiceFBR/DeleteBulkInvoices/${businessID}?userID=${userID}`, ids)
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data);
            } else {
              reject(response.data.message || 'Error deleting invoices');
            }
          })
          .catch((error) => {
            console.error('=== SalesInvoiceStoreModule BulkDelete error', error);
            reject(error);
          });
      });
    },
  },
};
